import React, { useEffect } from "react";

import PropTypes from "prop-types";
import { Select, Field, Icon, Control, Button } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Pagination({
  page,
  pages,
  onClickPrev,
  onClickNext,
  canNextPage,
  canPreviousPage,
  pageSize,
  setPageSize
}) {
  useEffect(() => {
    const handleKeyDown = e => {
      if (canNextPage && e.keyCode === 39) {
        onClickNext();
      }
      if (canPreviousPage && e.keyCode === 37) {
        onClickPrev();
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [canNextPage, canPreviousPage, onClickNext, onClickPrev]);

  return (
    <div className="data-table-pagination">
      <Field align="right" kind="group" size="small">
        <Control>
          <Button
            className="prev"
            color="primary"
            disabled={!canPreviousPage}
            role="button"
            size="small"
            onClick={onClickPrev}
          >
            <Icon>
              <FontAwesomeIcon icon="arrow-left" />
            </Icon>
          </Button>
        </Control>
        <Control>
          <Select.Container size="small">
            <Select
              value={pageSize}
              onChange={e => {
                setPageSize(parseInt(e.target.value), 10);
              }}
            >
              {[15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 50, 100].map(ps => (
                <Select.Option key={ps} value={ps}>
                  Show {ps}
                </Select.Option>
              ))}
            </Select>
          </Select.Container>
        </Control>
        <Control>
          <Button disabled size="small">
            {page} / {pages}
          </Button>
        </Control>
        <Control>
          <Button
            className="next"
            color="primary"
            disabled={!canNextPage}
            role="button"
            size="small"
            onClick={onClickNext}
          >
            <Icon>
              <FontAwesomeIcon icon="arrow-right" />
            </Icon>
          </Button>
        </Control>
      </Field>
    </div>
  );
}

Pagination.propTypes = {
  pages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onClickNext: PropTypes.func.isRequired,
  onClickPrev: PropTypes.func.isRequired,
  canNextPage: PropTypes.bool.isRequired,
  canPreviousPage: PropTypes.bool.isRequired,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func
};

export default Pagination;
